module.exports = __webpack_public_path__ + "img/mv_logo_trans.b28fd244.png";